var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kd-scale-buttons"},[_c('div',{staticClass:"kd-scale-buttons__inner-wrapper"},[_c('div',{staticClass:"kd-scale-button kd-scale-button--bigger",style:({
        backgroundImage: ("url(" + _vm.zoomInIcon + ")"),
      }),on:{"click":_vm.biggerButtonClicked}}),_c('div',{staticClass:"kd-scale-button kd-scale-button--smaller",style:({
        backgroundImage: ("url(" + _vm.zoomOutIcon + ")"),
      }),on:{"click":_vm.smallerButtonClicked}})])])}
var staticRenderFns = []

export { render, staticRenderFns }